<template>
  <el-row class="chat-frame">
    <!-- 欢迎语 -->
    <el-col :span="24" class="welcome-speech">
      {{ chatData.greeting }}
    </el-col>
    <chat-item :chatData="chatData"></chat-item>
  </el-row>
</template>

<script>
import chatItem from '@/components/client/inquiry/chatItem.vue';
import { mapGetters } from 'vuex';
export default {
  props: {
    chatData: {
      required: true
    }
  },
  data() {
    return {};
  },
  mounted() {},
  components: { chatItem },
  computed: {
    ...mapGetters(['fbmessagechat'])
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
.chat-frame {
  .welcome-speech {
    color: #666666;
    text-align: center;
    line-height: 60px;
    font-size: 14px;
    margin-bottom: 40px;
  }
}
</style>
